import React from "react";
import { Alert, Button, Form, Input, Radio } from "antd";
import { SendOutlined, StopOutlined } from '@ant-design/icons';
import { /*enmDamageCaseStatus, enmEvaluationStatus,*/ enmPolicyholderResponseTypes } from "../../baseInfo/damageCase/interfaces";
import { enmEntityState, IEntity } from "../../components/infrastructure/models";
import { IEvaluationComponentFormProps } from "./evaluationComponent";
import TextArea from "antd/lib/input/TextArea";
import { IBank } from "../../baseInfo/bank/interfaces";
import { Lookup } from "../../components/lookup";
import { IBaseComponent } from "../../components/infrastructure/baseComponent";
import { enmControlType, IProperty } from "../../components/entityManager/interfaces";
import { Bank } from "../../baseInfo/bank";

type LayoutType = Parameters<typeof Form>[0]['layout'];

export const policyholderResponseTypesOptions = [
    { title: "پرداخت", name: 'با متن فوق و مبلغ ارزیابی موافق هستم ', value: enmPolicyholderResponseTypes.Pay },
    { title: "عدم تایید", name: 'با مبلغ ارزیابی موافق نیستم', value: enmPolicyholderResponseTypes.Objection },
    //{ title: "تعمیر", value: enmPolicyholderResponseTypes.Repair }
];

export interface IPolicyholderConfirmation extends IEntity {
    DamageCaseEvaluatorId: number;
    ResponseType: enmPolicyholderResponseTypes;
    ObjectionDescription?: string;
    ShebaNo?: string;
    PossessionTransition?: boolean;
    BankId?: number;
    Bank?: IBank;
    BankBranch?: string;
    BankAccountNo?: string;
    BankCardNo?: string;
}

export interface IPolicyholderConfirmationFormProps extends IEvaluationComponentFormProps<IPolicyholderConfirmation> {
    policyholderPanel?: boolean;
    parent: IBaseComponent;
}

export interface IPolicyholderConfirmationFormState {
    responseType?: enmPolicyholderResponseTypes;
}

export const PolicyholderConfirmationForm = (props: IPolicyholderConfirmationFormProps) => {
    const formItemLayout = {
        labelCol: { xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 6 },
        wrapperCol: { xxl: 12, xl: 16, lg: 18, md: 18, sm: 18, xs: 20 },
    };

    const [state, setState] = React.useState<IPolicyholderConfirmationFormState>({ responseType: props.currentEntity.ResponseType });
    const [formLayout] = React.useState<LayoutType>('horizontal');
    const [form] = Form.useForm();

    const bankProp = React.useRef<IProperty>({
        controlType: enmControlType.lookup,
        dataIndex: "BankId",
        width: "100%",
        lookup: {
            lookupComponent: Bank,
            lookupProperty: "Code",
            lookupDisplayFields: ["Name"],
            showButton: false
        }
    });

    const shebaNoRef = React.useRef<Input>(null);
    const cardNoRef = React.useRef<Input>(null);

    React.useEffect(() => {
        let currentEntity = props.currentEntity as any;
        form.setFieldsValue(currentEntity);
    }, [props, form]);

    //const { DamageCaseEvaluators } = props.damageCase;
    //const lastDamageCaseEvaluatorId = !!DamageCaseEvaluators && DamageCaseEvaluators.length ? DamageCaseEvaluators[DamageCaseEvaluators.length - 1].Id : 0;

    const { PolicyEquipmentModel, PayableAmount, PayableAmountString } = props.damageCase;
    const { Policyholder } = PolicyEquipmentModel.Policy;

    return (
        <Form
            style={{ padding: '5px 45px' }}
            form={form}
            {...formItemLayout}
            layout={formLayout}
            onFinish={async (values) => {
                props.onSubmit && await props.onSubmit(values);
            }}
            onReset={() => {
                props.onClose && props.onClose(this);
            }}
        >

            <>
                <p> اینجانب : <b>{Policyholder.FullName}</b> به شماره ملّی : <b>{Policyholder.NationalCode}</b> بدینوسیله اقرار و اعتراف می‌نماید :</p>

                <p>
                    <span> در ازاء تأیدیه خسارت وارده به یک دستگاه : </span>
                    <b style={{ unicodeBidi: "plaintext" }} >{PolicyEquipmentModel.Equipment.Name} {PolicyEquipmentModel.BrandTitle} {PolicyEquipmentModel.EquipmentModelTitle}</b>
                    <span style={{ unicodeBidi: "plaintext" }}> به شماره سریال/IMEI : </span>
                    <b style={{ unicodeBidi: "plaintext" }} >{PolicyEquipmentModel.EquipmentSerialNo}</b>
                </p>

                <p>به (مبلغ : <b>{`${PayableAmount ?? 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</b> ریال) (حروف : <b>{PayableAmountString}</b> ريال)</p>

                <p style={{ textAlign: "justify" }}>
                    منبعد تحت هیچ عنوان اعتراض و ادعایی علیه شرکت بیمه سامان از بابت خسارت فوق الذکر نداشته و نخواهد داشت و بدینوسیله کلیه حقوق واقعی و منصوره ناشی از وقوع حادثه موضوع پرونده خسارت مزبور اعم از حق تعقیب قضایی و مطالبه و وصول مبلغ فوق و خسارات قانونی از مسبب یا مسببین و یا مسئول یا مسئولین حادثه را به شرکت بیمه سامان واگذار می نماید و نیز تعهّد می کند که نسبت به حادثه و خسارت واقع شده هیچگونه سازش، صلح یا توافقی با مقصر یا مقصرین و مسئول یا مسئولین وقوع حادثه نکرده و نخواهد کرد و از هر عملی که موجب تضییع حقوق و یا سقوط حق مراجعه شرکت بیمه سامان به مسئول و یا مسئولین یا مقصرین حادثه و یا مغایر فوق باشند، خودداری نماید و در صورتیکه عملی خلاف این تعهّد انجام داده یا بدهد، متعهّد و ملزم است علاوه بر مسترد نمودن مبالغ دریافتی به شرکت بیمه سامان از عهده خسارت وارده به آن شرکت نیز برآید. در صورت وقوع هرگونه خسارت (اعم از جزئی، کلی و سرقت)، پرداخت خسارت توسط شرکت بیمه سامان منوط به ارائه داغی قطعه تعویض شده توسط بیمه‌گذار به شرکت بیمه سامان می باشد، در غیر اینصورت شرکت بیمه سامان هیچگونه تعهّدی برای پرداخت خسارت نخواهد داشت. و همچنین ضروری است در صورت وقوع سرقت با شکست حرز، سرقت کُلی و خسارت کُلی، مالکیت دستگاه از طریق سایت همتا به شرکت بیمه سامان انتقال یابد و تمامی متعلقات دستگاه از قبیل : (جعبه، شارژر، سیم شارژر، هندزفری، قلم، بند ساعت هوشمند، باطری لپ تاپ و...) تحویل شرکت بیمه سامان گردد و در صورت ارائه نشدن هر کدام از موارد ذکر شده مبلغی از خسارت پرداختی کسر می گردد و اینجانب اعتراضی در خصوص آنها نخواهم داشت.
                </p>

            </>
            <Form.Item
                name={'ResponseType'}
                key={'ResponseType'}
                rules={[
                    {
                        required: true,
                        message: 'پاسخ اجباری است'
                    }
                ]}
            >
                <Radio.Group key={'ResponseType'} disabled={props.disabled} onChange={e => setState({ responseType: e.target.value })}>
                    {policyholderResponseTypesOptions.map(s =>
                        <Radio key={s.value} value={s.value}><b>{s.name}</b></Radio>
                    )}
                </Radio.Group>
            </Form.Item>

            {state?.responseType === enmPolicyholderResponseTypes.Objection &&
                <Form.Item
                    label={'شرح اعتراض'}
                    name={'ObjectionDescription'}
                    key={'ObjectionDescription'}
                    rules={[
                        {
                            required: state?.responseType === enmPolicyholderResponseTypes.Objection,
                            message: 'شرح اعتراض اجباری است'
                        }
                    ]}
                >
                    <TextArea disabled={props.disabled} rows={10} />
                </Form.Item>
            }

            {state?.responseType === enmPolicyholderResponseTypes.Pay &&
                <>
                {!props.disabled && < Alert style={{ marginTop: 10, marginBottom: 10 }} message="امکان انجام عملیات انتقال وجه، به حساب های بلو بانک و همچنین بانک/ موسسات اعتباری ادغام شده با بانک سپه (شامل: بانک‌های انصار، قوامین، حکمت ایرانیان، موسسه اعتباری مهر اقتصاد و کوثر) نمی باشد، خواهشمند است اطلاعات حساب بانکی به غیر از بانک‌ها و موسسات مذکور را ثبت نمایید." type="warning" showIcon />}

                    <p>مشخصات حساب بانکی بیمه‌گذار محترم :</p>

                    <Form.Item
                        label={'شماره شبا'}
                        name={'ShebaNo'}
                        key={'ShebaNo'}
                        rules={[
                            {
                                required: true,
                                message: 'شماره شبا اجباری است'
                            },
                            {
                                len: 26,
                                message: 'تعداد ارقام باید 24 باشد'
                            }
                        ]}
                    >

                        <Input
                            autoComplete="off"
                            disabled={props.disabled}
                            maxLength={26}
                            ref={shebaNoRef}
                            type={"text"}
                            onKeyPress={(event: any) => {
                                if (event.charCode < 48 || event.charCode > 57) {
                                    event.preventDefault();
                                }
                                if (shebaNoRef.current) {
                                    const { input } = shebaNoRef.current;
                                    input.selectionStart = input.selectionEnd = (event.target as any).value.length;
                                    if (input.value.indexOf('IR') === -1)
                                        input.value = `IR${input.value.replace(/[^0-9.]/g, '')}`;
                                }
                            }}
                            onPaste={e => {
                                e.preventDefault();
                                let text = e.clipboardData.getData('Text');
                                if (shebaNoRef.current) {
                                    let shebaNo: string = form.getFieldValue('ShebaNo');
                                    if (shebaNo.indexOf('IR') === -1)
                                        shebaNo = `IR${shebaNo}${text.replace(/[^0-9.]/g, '')}`;
                                    else
                                        shebaNo = `${shebaNo}${text.replace(/[^0-9.]/g, '')}`;
                                    form.setFieldsValue({ ShebaNo: shebaNo.substring(0, 26) });
                                }
                            }}
                            style={{ direction: 'ltr', maxWidth: 400 }} placeholder="IR...." />
                    </Form.Item>

                    <Form.Item
                        name="Bank"
                        key="Bank"
                        label="بانک"
                        rules={[
                            { required: true, message: 'انتخاب بانک اجباری است' }
                        ]}
                    >
                        <Lookup
                            parent={props.parent}
                            disabled={props.disabled}
                            property={bankProp.current}
                            style={{ maxWidth: 400 }}
                        />
                    </Form.Item>

                    <Form.Item
                        label={'شعبه بانک'}
                        name={'BankBranch'}
                        key={'BankBranch'}
                    >
                        <Input
                            style={{ direction: 'ltr', maxWidth: 400 }}
                            maxLength={100}
                            disabled={props.disabled}
                        />

                    </Form.Item>

                    <Form.Item
                        label={'شماره حساب'}
                        name={'BankAccountNo'}
                        key={'BankAccountNo'}
                    >
                        <Input
                            style={{ direction: 'ltr', maxWidth: 400 }}
                            maxLength={20}
                            disabled={props.disabled}
                        />

                    </Form.Item>

                    <Form.Item
                        label={'شماره کارت'}
                        name={'BankCardNo'}
                        key={'BankCardNo'}
                        rules={[
                            {
                                validator: () => {
                                    const bankCardNo = form.getFieldValue('BankCardNo')?.replace(/[^0-9.]/g, '');
                                    if (!!bankCardNo && bankCardNo.length !== 16)
                                        return Promise.reject(new Error('شماره کارت نامعتبر است'));
                                    return Promise.resolve();
                                }
                            }
                        ]}
                    >
                        <Input
                            style={{ direction: 'ltr', maxWidth: 400 }}
                            maxLength={19}
                            disabled={props.disabled}
                            ref={cardNoRef}
                            type={"text"}
                            onKeyPress={(event: any) => {
                                if (event.charCode < 48 || event.charCode > 57)
                                    event.preventDefault();
                                if ((event.target as any).value.replace(/[^0-9.]/g, '').length === 16)
                                    event.preventDefault();
                            }}
                            onKeyUp={(event) => {
                                if (cardNoRef.current) {
                                    const { input } = cardNoRef.current;
                                    input.selectionStart = input.selectionEnd = (event.target as any).value.length;
                                    input.value = `${input.value.replace(/[^0-9.]/g, '').replace(/(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/,// '$1-$2-$3-$4')}`;
                                        (_, p1, p2, p3, p4) => {
                                            let result = '';
                                            if (!!p1)
                                                result = p1 + (p1.length === 4 ? '-' : '');
                                            if (!!p2)
                                                result += p2 + (p2.length === 4 ? '-' : '');
                                            if (!!p3)
                                                result += p3 + (p3.length === 4 ? '-' : '');
                                            if (!!p4)
                                                result += p4;
                                            return result;
                                        })
                                        }`
                                }
                            }}
                        />

                    </Form.Item>

                    {
                    props.currentEntity.State === enmEntityState.Added && <Alert style={{ marginTop: 10, marginBottom: 10 }} message="بیمه گزار/مشتری گرامی، اطلاعات حساب بانکی می‌بایست بنام دارنده بیمه نامه باشد." type="info" showIcon />
                    }
                </>
            }

            {/*{props.policyholderPanel === true && props.damageCase.NumberOfPreviousEvaluations > 0 && props.currentEntity.DamageCaseEvaluatorId === lastDamageCaseEvaluatorId && props.damageCase.Status === enmDamageCaseStatus.Rejected && props.damageCase.EvaluationStatus === enmEvaluationStatus.PolicyholderRejected*/}
            {/*    ? <Alert style={{ margin: 10 }} message="در صورت تمایل لطفاً با شماره 8943-021 تماس گرفته و شکایت نمایید." type="warning" showIcon />*/}
            {/*    : <></>}*/}

            {props.disabled === true ? <></> :
                <Form.Item wrapperCol={{ dir: 'ltr' }} style={{ zIndex: 1000, borderTop: '1px solid', borderColor: '#e5e5e5', marginTop: 10 }}>
                    <Button type="primary" htmlType="submit" icon={<SendOutlined rotate={180} />} loading={props.loading} style={{ width: "100px", marginTop: 10, marginBottom: 10 }}>
                        ثبت
                    </Button>
                    <Button type="ghost" htmlType="reset" icon={<StopOutlined />} loading={props.loading} style={{ width: "100px", marginTop: 10, marginBottom: 10, marginLeft: 10, background: '#fff' }}>
                        لغو
                    </Button>
                </Form.Item>
            }
        </Form>
    );
}